// @flow

import * as React from 'react';
import {useRandom} from 'docs/data';
import type {Alphabet} from 'docs/data';

type RandomProps = {|
  alphabet?: Alphabet,
  length: number,
|};

export const Random = ({alphabet = 'alphanumeric', length}: RandomProps) => {
  const {generateRandomString} = useRandom();
  const content = generateRandomString(length, alphabet);
  return <span>{content}</span>;
};
